module.exports = __webpack_public_path__ + "static/media/pdf.e115a6dc.jpg";